export default "__VITE_IMAGE_ASSET__a8668dc0__";